// extracted by mini-css-extract-plugin
export default {"formWrapper":"ColumnForm_formWrapper__mB7Cl","columnFrom":"ColumnForm_columnFrom__4KW47","label":"ColumnForm_label__MUnmt"};